import React from 'react'
import { Discount } from 'components/NotProductIcons'
import Link from 'components/Link'

const DiscountSection = ({ discounts }) => {
    return (
        <div>
            <h4 className="mb-3 border-b border-dashed border-gray-accent-light pb-2">{discounts?.title}</h4>
            {discounts?.options.map((option, index) => (
                <div key={index} className="relative mb-4 pl-10">
                    <span className="absolute top-0 left-1 h-6 w-6">
                        <Discount />
                    </span>
                    <h5 className="mb-0 text-base">{option?.title}</h5>
                    <p className="mb-1 text-[15px]">
                        {option?.text} <Link to={option?.url}>{option?.text2}</Link>.
                    </p>
                </div>
            ))}
        </div>
    )
}

export default DiscountSection
